export enum SearchParamsEnum {
  token = 'token',
  leagueType = 'leagueType',
  lang = 'lang',
  leagueId = 'leagueId',
  viewType = 'viewType',
  entryId = 'entryId',
}
